import { OfferCardSkeleton } from './OfferCardSkeleton.tsx'

interface OfferCardsSkeletonProps {
	count: number
}

export const OfferCardsSkeleton = ({ count }: OfferCardsSkeletonProps) => {
	const elements = Array.from({ length: count }, (_, index) => index)

	return (
		<>
			{elements.map(el => (
				<div
					className="w-full max-w-[18.5rem] self-center"
					key={el}
				>
					<OfferCardSkeleton />
				</div>
			))}
		</>
	)
}
